// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DyKcL","toggleWrap":"styles_toggleWrap__2PI-8","content":"styles_content__V6hNS","selectAreaCode":"styles_selectAreaCode__WcUxK"};